export default function HeroSection() {
  return (
    <section className="relative w-full h-[75vh] min-h-[600px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/716de374ac8c096490e44af7ea956fbf.jpg"
        alt="Cabins in Highlands NC nestled in the Blue Ridge Mountains"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/60" />
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 pt-20">
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Highlands NC Cabin Guide</p>
        <h1 className="font-cormorant text-5xl md:text-6xl lg:text-7xl text-white font-light leading-tight mb-5 max-w-4xl">
          Cabins in Highlands, NC
        </h1>
        <p className="text-white/75 font-jost text-sm leading-relaxed max-w-2xl">
          Highlands, North Carolina is one of the most beautiful mountain destinations in the Blue Ridge Mountains. Whether you&apos;re looking for a luxury cabin, a pet friendly rental, or a cozy getaway near downtown, there are many incredible cabins in Highlands, NC to choose from.
        </p>
      </div>
    </section>
  );
}
